import React, { useState, useEffect } from 'react';

const ImpactSection: React.FC = () => {
  const [activeItem, setActiveItem] = useState<string>('tragedy');
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const timelineData = [
    {
      id: 'tragedy',
      label: 'TRAGEDY',
      grayImage: '/images/gm-time.png',
      greenImage: '/images/gm-time-green.png',
      message: 'A child dies every minute from malaria.'
    },
    {
      id: 'mortality',
      label: 'MORTALITY',
      grayImage: '/images/gm-target.png',
      greenImage: '/images/gm-target-green.png',
      message: 'Malaria accounts for 1 in 12 global deaths in children under 5.'
    },
    {
      id: 'crisis',
      label: 'CRISIS',
      grayImage: '/images/gm-cross.png',
      greenImage: '/images/gm-cross-green.png',
      message: '80% of annual malaria deaths are among African children under five.'
    },
    {
      id: 'epidemic',
      label: 'EPIDEMIC',
      grayImage: '/images/gm-africa.png',
      greenImage: '/images/gm-africa-green.png',
      message: 'Malaria continues to be a significant health concern for the Africa Region, which accounts for 95% of all global malaria cases and 96% of all malaria deaths.'
    }
  ];

  // Auto-cycle through timeline items (only when not hovered)
  useEffect(() => {
    if (isHovered) return; // Don't auto-cycle when hovering

    const interval = setInterval(() => {
      setActiveItem(prevItem => {
        const currentIndex = timelineData.findIndex(item => item.id === prevItem);
        const nextIndex = (currentIndex + 1) % timelineData.length;
        return timelineData[nextIndex].id;
      });
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval);
  }, [isHovered]);

  return (
    <section className="gm-impact-section">
      <div className="container">
        <h2 className="gm-impact-heading">
          Malaria's Impact in Africa
        </h2>
        
        <div className="gm-timeline">
          {timelineData.map((item) => (
            <div 
              key={item.id}
              className={`gm-timeline-item ${activeItem === item.id ? 'active' : ''}`}
              onMouseEnter={() => {
                setIsHovered(true);
                setActiveItem(item.id);
              }}
              onMouseLeave={() => setIsHovered(false)}
            >
              <img 
                src={activeItem === item.id ? item.greenImage : item.grayImage}
                alt={item.label} 
                className="gm-timeline-image"
              />
              <div className="gm-timeline-label">{item.label}</div>
            </div>
          ))}
        </div>
        
        <div className="gm-timeline-message">
          {timelineData.find(item => item.id === activeItem)?.message}
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;
